import 'core-js/fn/array/flat-map';

import React from 'react';
import { render } from 'react-dom';

import Button from '@material-ui/core/Button';

import { Router } from 'react-router-dom';
import { Provider } from 'react-redux';
import { OidcProvider } from 'redux-oidc';
import { SnackbarProvider } from 'notistack';
import { MuiThemeProvider } from '@material-ui/core/styles';

import store from './providers/redux';
import manager from './providers/oidc';
import history from './providers/history';
import { mui } from './config/theme';

import Main from './main';

render(
  <Provider store={store}>
    <OidcProvider store={store} userManager={manager} >
      <MuiThemeProvider theme={mui}>
        <Router history={history}>
          <SnackbarProvider
            action={[
              <Button key={1} size="small">Fechar</Button>
            ]}
            maxSnack={6}
          >
            <Main />
          </SnackbarProvider>
        </Router>
      </MuiThemeProvider>
    </OidcProvider>
  </Provider>, document.querySelector('#root'));
